import { useState } from "react";
import { Copy, Check, Link2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

// Shareable sign-in link that shows this company's logo and pre-fills its company ID.
export const SignInLinkCard = () => {
    const { user } = useAuth();
    const [copied, setCopied] = useState(false);
    const link = `${window.location.origin}/login?company=${encodeURIComponent(user?.company_id || "")}`;

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(link);
            setCopied(true);
            toast.success("Sign-in link copied");
            setTimeout(() => setCopied(false), 2000);
        } catch {
            toast.error("Copy failed — select the link and copy it manually");
        }
    };

    return (
        <section className="mt-8 bg-white border border-ink/10 p-6 flex flex-wrap items-center gap-4" data-testid="settings-signin-link">
            <div className="w-11 h-11 rounded-xl bg-klein-50 text-klein flex items-center justify-center shrink-0"><Link2 className="w-5 h-5" /></div>
            <div className="min-w-0 flex-1">
                <div className="font-semibold text-ink">Your staff sign-in link</div>
                <div className="text-sm text-ink/60">Share it with staff — it shows your logo and fills in your company ID.</div>
                <code className="mt-2 block text-xs text-klein break-all" data-testid="settings-signin-link-url">{link}</code>
            </div>
            <button type="button" onClick={copy} className="inline-flex items-center gap-2 border border-ink/20 px-4 py-2.5 text-sm hover:bg-ink/5" data-testid="settings-signin-link-copy">
                {copied ? <Check className="w-4 h-4 text-emerald-600" /> : <Copy className="w-4 h-4" />} {copied ? "Copied" : "Copy link"}
            </button>
        </section>
    );
};

export default SignInLinkCard;
